
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoogleTagManagerBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EX_MARKETING_GoogleTagManager"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"container_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_user_data"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_page_view"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_view_item"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_view_item_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_select_item"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_add_to_cart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_remove_from_cart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_view_cart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_begin_checkout"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_add_shipping_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_add_payment_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_purchase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track_search"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":427}};
    doc.loc.source = {"body":"fragment GoogleTagManagerBase on EX_MARKETING_GoogleTagManager {\n    id\n    container_id\n    is_enabled\n    send_user_data\n    track_page_view\n    track_view_item\n    track_view_item_list\n    track_select_item\n    track_add_to_cart\n    track_remove_from_cart\n    track_view_cart\n    track_begin_checkout\n    track_add_shipping_info\n    track_add_payment_info\n    track_purchase\n    track_search\n    created_at\n    updated_at\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GoogleTagManagerBase"] = oneQuery(doc, "GoogleTagManagerBase");
        
